import chevron from "../../../../assets/chevron.svg";
import styles from "./NavMenu.module.css";
import NavOption from "../NavOption";

const AuditReportsMenu = ({ ACTIONS, dispatch, state, closeMenus }) => {
  const onClickHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.AUDIT_REPORTS_MENU_TOGGLE });
  };

  const closeMenu = () => {
    closeMenus();
  };

  const onBlurHandler = (event) => {
    event.preventDefault();
    if (
      !state.mobileMenuOpen &&
      !event.currentTarget.contains(event.relatedTarget)
    ) {
      closeMenu();
    }
  };

  const chevronClass = state.auditReportsMenuOpen
    ? styles.chevronFocused
    : styles.chevron;

  const rootButtonClass = state.auditReportsMenuOpen
    ? styles.titleButtonMenuFocused
    : styles.titleButtonMenu;

  return (
    <li onBlur={onBlurHandler}>
      <button className={rootButtonClass} onClick={onClickHandler}>
        Audit Reports
        <img className={chevronClass} src={chevron} alt="" />
      </button>
      {state.auditReportsMenuOpen && (
        <ul className={styles.subMenu1}>
          <NavOption
            displayText={"Splicer Audits"}
            navigateTo={"/splicerAuditReport"}
            closeParentMenu={closeMenu}
            ACTIONS={ACTIONS}
            dispatch={dispatch}
            state={state}
            closeMenus={closeMenus}
          />
        </ul>
      )}
    </li>
  );
};

export default AuditReportsMenu;
